<ng-container *ngIf="viewModel$ | async  as vm" >

  <div class="container">

    <div class="month previous-month" [class.no-data-previous]="hasNoData(vm.previousHours)" [ngStyle]="{'height': getHeight(getPreviousMonthHeight(vm.report, vm.scale))}"> 
      <app-text class="hours is-family-semiBold text-18" *ngIf="!hasNoData(vm.previousHours)">
        {{ vm.previousHours + 'h' }}
      </app-text>
      <app-text *ngIf="hasNoData(vm.previousHours)" class="no-data-text text-salmon-pink">
        {{'common-app.__NO_DATA' | AsyncLang | async}}
      </app-text>
    </div>
    <div class="month current-month" [class.no-data]="hasNoData(vm.currentHours)" [ngStyle]="{'height': getHeight(getCurrentMonthHeight(vm.report, vm.scale))}">
      <app-text class="hours is-family-semiBold text-18" *ngIf="!hasNoData(vm.currentHours)">
        {{vm.currentHours + 'h'}}
      </app-text>
      <app-text *ngIf="hasNoData(vm.currentHours)" class="no-data-text text-netatmo-orange is-family-semiBold">
        {{'common-app.__NO_DATA' | AsyncLang | async}}
      </app-text>
    </div>
  </div>

  <div class="legend">
    <app-text class="month-legend text-grey-70 is-family-semiBold has-spacing-m text-18">{{getPreviousMonthTextScale(vm.report, vm.scale)}}</app-text>

    <app-text class="month-legend text-grey-70 is-family-semiBold has-spacing-m text-18">{{getMonthText(vm.report, vm.scale)}}</app-text>
  </div>
  
</ng-container>